import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BusinessHourTemplate } from 'components/Templates'

const BusinessHour: FC = () => {
  return (
    <Layout headline={'店舗基本情報の編集'} title={'営業時間・定休日を修正'}>
      <BusinessHourTemplate />
    </Layout>
  )
}

export default BusinessHour
